<template>
  <div class="login_container"  style="background-image: url('static/img/back3.png');">
    
      <div id="login_title" class="login_title">{{title}}</div>
      <div class="ui form" style="margin-top: 80px">
        <div class="field">
          <input v-model="user.Username" style="width: 92%" type="text" name="username" placeholder="请输入用户名">
        </div>
        <div class="field">
          <input v-model="user.Password" style="width: 92%" type="password" name="password" placeholder="请输入密码">
        </div>
        <div class="field" style="height: 20px">
          <div style="float: left;" >
            <input style="height: 19px" type="checkbox" class="hidden" v-model="remember">
            <label>记住密码</label>
          </div>
        </div>
        <button @click="onLogin" style="width: 100%" class="ui teal button" >登 录</button>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import { login, getClient } from "@/api/api";
import { mapState } from "vuex";
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      user:{
        Username:"",
        Password:""
      },
      remember:true
    }
  },
  mounted(){
    this.remember=localStorage.getItem("remember")=="true"?true:false
    this.user.Username=localStorage.getItem("u_username")
    this.user.Password=localStorage.getItem("u_password")
  },
  computed: {
    ...mapState(["clientInfo"]),
    title() {
      return window.title || '微站监测系统'
    }
  },
  methods:{
    onLogin(){
      if (!this.user.Username) {
        Toast.fail('请输入用户名');
        return
      }
      if (!this.user.Password) {
        Toast.fail('请输入密码');
        return
      }
      getClient(this.user.Username)
        .then(c => {
          if (c.data.code !== 200) {
            this.$message.error(c.data.msg);
            return;
          }
          this.$store.commit("setClientInfo", c.data.data);

          let data = {
            username:this.user.Username,
            password: this.user.Password,
            grant_type: "password",
            client_id: this.clientInfo.clientId,
            client_secret: this.clientInfo.clientSecretStr
          };
          login(data)
            .then(d => {
              if (d.data.access_token) {
                let token = d.data.access_token;
                this.$store.commit("setToken", token);
                localStorage.setItem("yc_token", token);
                localStorage.setItem("remember", this.remember)

                if (this.remember) {
                  localStorage.setItem("u_username", this.user.Username);
                  localStorage.setItem("u_password", this.user.Password);
                } else {
                  localStorage.removeItem("u_username");
                  localStorage.removeItem("u_password");
                }

                this.$store.commit("setLoginAsDefault", false);
                this.$router.replace({name: 'index'})

                this.$store.dispatch("init", () => {
                  this.$router.replace({ name: "index" });
                });
              } else {
                Toast.fail("登录失败");
              }
            })
            .catch(e => {
              console.log(e);
              if (e.response) {
                Toast.fail(e.response.data.msg || "登录失败");
              } else {
                Toast.fail("登录失败");
              }
            });
        })
        .catch(e => {
          console.log(e);
          this.$message.error(e.response.data.msg || "登录失败");
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_container{
  text-align: center;
  color: #2c3e50;
  padding: 100px 20px 0 20px;
  background-repeat: no-repeat;
  background-size: cover;
  height: calc(100vh - 100px);  
}
.login_title{
  font-size: 20px;
  color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue